import { Tabs } from "components/common";
import { useState } from "react";
import BalanceSubPage from "./balance/BalanceSubPage";
import LogSubPage from "./log/LogSubPage";
import { Wrapper } from "./LoyaltyWalletPage.styled";
import PendingSubPage from "./pending/PendingSubPage";
import SendModal from "./transfer/SendModal";

const { TabPane } = Tabs;

export default function LoyaltyWalletPage() {
  const [selectedTab, setSelecetedTab] = useState("Gift Wallet Balance");
  const [modalMode, setModalMode] = useState(undefined);
  const [shouldLoad, setShouldLoad] = useState(false);

  return (
    <Wrapper>
      <div className="main-container">
        <div className="subscriptions-tabs">
          <Tabs activeKey={selectedTab} onChange={(e) => setSelecetedTab(e)}>
            <TabPane
              tab={
                <span
                  className={
                    selectedTab == "Gift Wallet Balance"
                      ? "active-tab"
                      : "inactive-tab"
                  }
                >
                  Gift Wallet Balance
                </span>
              }
              key="Gift Wallet Balance"
            />
            {/* <TabPane
              tab={
                <span
                  className={
                    selectedTab == "Current Gift Wallet"
                      ? "active-tab"
                      : "inactive-tab"
                  }
                >
                  Current Gift Wallet
                </span>
              }
              key="Current Gift Wallet"
            /> */}
          </Tabs>
        </div>
      </div>
      {selectedTab == "Gift Wallet Balance" && (
        <>
          <div className="loyal-rewar-bal">
            <BalanceSubPage setModalMode={setModalMode} />
          </div>
          <div className="loyal-rewar-bal" style={{ marginTop: "24px" }}>
            <LogSubPage shouldLoad={shouldLoad}/>
          </div>
        </>
      )}
      {selectedTab == "Current Gift Wallet" && <PendingSubPage />}

      {modalMode === "send" && (
        <SendModal setModalMode={setModalMode} setShouldLoad={setShouldLoad} />
      )}
    </Wrapper>
  );
}
